/** Spacing and size tokens — docs/sprocket-design-language.md §4, §5. All px. */
/** 4px base; MUI `theme.spacing(n)` = n × this. */
export const SPACE_BASE = 4;
export const SPACE = {
    pageGutter: { desktop: 32, tablet: 24, phone: 16 },
    headerToContent: 20,
    cardPadding: { desktop: 20, phone: 16 },
    sectionGap: 20,
    /** List rows: top/bottom. */
    listRowY: 9,
    /** Table cells: vertical × horizontal. */
    tableCell: { y: 9, x: 12 },
};
export const SIZE = {
    /** Control heights: in-table · default · auth forms. */
    control: { small: 28, medium: 32, large: 38 },
    /** Minimum target on coarse pointers (WCAG 2.5.5). */
    touchTarget: 44,
    sidebarWidth: 240,
    /** Pages fill to this and centre; one width for every page (§1.8). */
    contentMaxWidth: 1400,
    /** Reading pages (forms, settings). */
    narrowMaxWidth: 920,
    /** Phone top row. */
    mobileBarHeight: 48,
    navRow: 32,
    /** Nav/list icon glyph size. */
    icon: { sm: 16, md: 18, lg: 22 },
};
//# sourceMappingURL=space.js.map